export default () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
		<path d="M3 6L5 8L9 4" stroke="#038331" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" />
	</svg>
);
